import React from 'react'
import { locationSearchToObject } from 'src/helper/url'
import { AppRouteComponentProps } from 'src/types'

export interface Props extends Omit<AppRouteComponentProps, 'queryParams'> {}

// 不同路由添加class，为支持换肤功能

export default class AppRouteComponent extends React.PureComponent<Props> {
  componentDidMount() {
    this.updateBodyClassNames()
  }
  componentWillUnmount() {
    this.updateBodyClassNames(true)
  }
  getPageClasses() {
    return this.props.route.pageClass ? this.props.route.pageClass.split(/\s/) : []
  }
  updateBodyClassNames(clear = false) {
    for (const cls of this.getPageClasses()) {
      clear ? document.body.classList.remove(cls) : document.body.classList.add(cls)
    }
  }
  render() {
    const { props } = this
    const RouteComponent = props.route.component
    return <RouteComponent {...props} queryParams={locationSearchToObject(props.location.search)} />
  }
}
